import SalesBanner from './SalesBanner'

export default SalesBanner
